export default {"src":"/_next/static/media/estateplan.dfc17aea.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};